import { useState, useCallback } from 'react';
import { requestPost } from '@/common/request';
import { message } from 'antd';

export enum LinkedType {
  category = 1, // 品类
  situation = 2, // 场景
}

export enum OperateType {
  unLinked = 0, // 取消关联
  linked = 1, // 关联
}

export interface Query {
  fieldId: string; // 场域id
  type: LinkedType; // 关联类型
  operateType: OperateType; // 操作类型
  ids: string[]; // 品类id或场景id列表
}

// 趋势场域关联趋势品类
export default function operateBusinessField(query: Query): Promise<RequestResult> {
  return requestPost('/generic/materialRpcService/operateBusinessField', query);
}

export function useAPIOperateBusinessField() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async function request(query: Query) {
      if (loading) return;
      setLoading(true);
      try {
        const { ret, msg, data } = await operateBusinessField(query);

        if (ret !== '0') {
          message.error(msg);
          setLoading(false);
          return;
        }

        setLoading(false);

        return { ret, msg, data };
      } catch (ex) {
        console.error(ex);
        message.error('请稍后重试');
      }
      setLoading(false);
    },
    [loading]
  );

  return [loading, request] as const;
}
